<template>
  <b-alert class="text-center" variant="primary" show dismissible>
    系統查找失效，請重新輸入搜尋代碼或稍待片刻
  </b-alert>
</template>

<script>
export default {
  name: "ErrorAlert"
};
</script>

<style lang="scss" scoped></style>
